/* tss-custom-footer.js — CACHED COPY of the static part of snippets/custom-scripts-footer-ssr.liquid
 * (SSR custom scripts, end of <body>, every page). Moved to a theme asset 2026-10-23 so it can be cached.
 * The 3 Liquid conditions it used are now flags in window.__tssFooterCfg, set inline by the snippet just before this file loads.
 * Loaded as a normal (sync, non-defer) script at the same spot, so execution order/timing is unchanged. */



$(".cc-rounded-full.cc-cursor-pointer.cc-p-2").click(function(){
    $("#tidio-chat").show();
});
$(".oem-color-change").click(function(){
    $("#tidio-chat").hide();
});
$(".site-nav__link.site-nav__link--icon.site-nav__compress-menu").click(function (params) {
    if ($("#MobileNav").hasClass("is-active")) {
        $("#MobileNav").removeClass("is-active");
    } else {
        $("#MobileNav").addClass("is-active");
    }
});

var live_cart_url = "https://thespraysource.com/cart"
window.actionProduct = (typeof meta !== 'undefined' && meta.product) || [];
popupSelectedVariant = null;

/* Note: an earlier iteration here pre-warmed the cart with a GET /cart.js
   on PDP load to fix a "first-click-fails" pattern. Tommy reported this
   made cart operations LAGGY because Shopify serializes cart endpoints
   per-session — if pre-warm is in flight when the user clicks ATC, the
   POST queues behind it. Removed in favor of relying on the auto-retry
   inside the cart-add handler, which handles the first-click failure
   case without adding latency to the happy path. */


/* ── Document-level submit capture for the shared ATC mutex ─────────────
   The minified `product-form.aio.min.js` (Dawn's <product-form> element)
   is what production actually loads — not assets/product-form.js. We can't
   patch the minified source directly without risking syntax breakage, so
   instead we install a capture-phase `submit` listener on `document` that
   runs BEFORE Dawn's per-form submit listener and gates it on the same
   `window.__tssAtcInFlight` mutex used by the legacy jQuery click handler
   below.

   Capture-phase only — bubble-phase would run AFTER Dawn's listener.

   Triggers when submit fires for any reason: selling-plan products (the
   legacy click handler returns before preventDefault on those, letting
   submit through), Enter key on the quantity input, or programmatic
   .submit() calls. The legacy handler's e.preventDefault() on click
   suppresses submit on regular non-selling-plan products, so this code
   path is mostly invisible there — it's the safety net for everything
   else.

   Strategy:
     1. Identify add-to-cart forms (action contains /cart/add, OR inside
        a <product-form> element, OR data-type="add-to-cart-form").
     2. If mutex is held → preventDefault + stopImmediatePropagation, so
        Dawn's submit listener never fires. The user clicks again later.
     3. If mutex is free → set it, arm a 5s safety release. Dawn proceeds
        normally; its .finally() doesn't know about our mutex, so the
        timer is what releases it.
   5s is plenty for a healthy /cart/add.js (typical ~200-800ms) and
   short enough that a stuck mutex doesn't strand the customer. */
document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    var action = form.getAttribute('action') || '';
    var isAtcForm = (
        action.indexOf('/cart/add') > -1 ||
        form.getAttribute('data-type') === 'add-to-cart-form' ||
        (form.closest && form.closest('product-form'))
    );
    if (!isAtcForm) return;
    if (window.__tssAtcInFlight) {
        e.preventDefault();
        e.stopImmediatePropagation();
        if (window.console) console.warn('[atc] dawn submit blocked — mutex held');
        return;
    }
    window.__tssAtcInFlight = true;
    setTimeout(function () {
        if (window.__tssAtcInFlight) {
            window.__tssAtcInFlight = false;
            if (window.console) console.info('[atc] safety release after dawn submit (5s)');
        }
    }, 5000);
}, true);

$(function () {







    function validate_payment_terms() {
        console.log('validate_payment_terms')
        setTimeout(function(){
            let hostElement = document.querySelector("shopify-payment-terms");
            if(hostElement && hostElement.shadowRoot && document.querySelector(".payment-terms-by-ssr")) {
              let shadowRoot = hostElement.shadowRoot; // Access the shadow root
              let span_exist = shadowRoot.children[0].children[0].children[0].textContent.indexOf("<span")
              if (span_exist>-1) {
                  document.querySelector(".payment-terms-by-ssr").style.display="none";  
              } else {
                  document.querySelector(".payment-terms-by-ssr").style.display="block";  
              }
            }
        },10)
    }

    $("input[name=id]").change(function(){
        validate_payment_terms();
    });

    // in case quantity added twice as we already attached it with last variant option
    if ($("block-quantity-selector").length>1) {
        $("block-quantity-selector").eq(1).remove()
    }

    $(window).on('scroll', function() {
        var headerHeight = $('#HeaderWrapper').outerHeight();
        var sm = $('#shopify-section-ss-circle-menu-pro').height();
        $('#shopify-section-ss-circle-menu-pro').css('top', headerHeight + 'px');
        $('.collection-filter').css('top', headerHeight+sm + 'px');
    });

    if (window.__tssFooterCfg.hasOptions) {
        if(!$("block-quantity-selector").length) {
            $("block-variant-picker").width("100%")
        }
    }
  
    $(document).on("click", "#desktop-flter-trigger", function (params) {
        if($(this).hasClass('showing')) {
            $(this).removeClass('showing');
            $(".filters-holder").hide()
        } else {
            $(this).addClass('showing');
          $(".filters-holder").show();
        }
    });
    $(document).on("click", "#close-filters", function (params) {
        $(".filters-holder").hide()
    });
    $(document).on("click", '.cldm-product-option .cldm-product-option-add-btn', function () {
        var current_price=0;
        var selected_variant = parseQueryString();
        if(undefined==selected_variant.variant) {
            current_price = window.actionProduct.variants[0].price
            current_price = (current_price/100);
        } else {
            $.each(window.actionProduct.variants, function(i,d){
                if(selected_variant.variant==d.id){
                    current_price = (d.price/100);
                }
            });
        }
        var main_quantity = 1;
        current_price = current_price*main_quantity;
        var price_change = parseFloat($(this).parent().data("price"));
        if ($(this).parent().hasClass('selected')) {
            $(this).parent().removeClass('selected');
            $(this).text('+ Add this');
        } else {
            $(this).parent().addClass('selected');
            $(this).text('- Remove');
        }
        get_sel_options_price(current_price).then( ( total_options_price ) => {
    }).catch( ( err ) => {
        console.log('error', err)
    });

});
	
    $(document).on("change", '.quantity-input', function (ev) {
        var current_price =0;
        var selected_variant = parseQueryString();
        if(undefined==selected_variant.variant){
            current_price = window.actionProduct.variants[0].price
            current_price = (current_price/100);
        } else {
            $.each(window.actionProduct.variants, function(i,d){
                if(selected_variant.variant==d.id){
                    current_price = (d.price/100);
                }
            });
        }
        var main_quantity = 1;
        current_price = current_price*main_quantity;
        if($(this).closest('.cldm-product-option').hasClass('selected')) {
            get_sel_options_price(current_price).then( ( total_options_price ) => {}).catch( ( err ) => { console.log('error', err); });
        }
    });
	
    $(document).on("change", '#productSelect-option-0, #productSelect-option-1', function (ev) {
		setTimeout(function(){
			var current_price=0;
			var selected_variant = parseQueryString();
			if(undefined==selected_variant.variant) {
				current_price = window.actionProduct.variants[0].price
				current_price = (current_price/100);
			} else {
				$.each(window.actionProduct.variants, function(i,d){
					if(selected_variant.variant==d.id){
						current_price = (d.price/100);
					}
				});
			}
			var main_quantity = 1;
			current_price = current_price*main_quantity;
			get_sel_options_price(current_price).then( ( total_options_price ) => {}).catch( ( err ) => { console.log('error', err); });
		}, 500);
	});

    // SELECTED VARIANT UPDATE ...
    const form = document.querySelector('.product-form');
    if(form){
        const variantInput = form.querySelector('input[name="id"]');
        form.addEventListener('change', () => {
            popupSelectedVariant = variantInput.value
            console.log('Selected variant:', popupSelectedVariant);
        });
    }

    // SELECTED VARIANT UPDATE ...


    
    $(document).on("change", ".ssr-oem-search-recommended-undercoat-checkbox", function() {
        if($(this).is(":checked")) {
            setTimeout(() => {
                var current_price=0;
                var selected_variant = parseQueryString();
                if(undefined==selected_variant.variant){
                    current_price = window.actionProduct.variants[0].price
                    current_price = (current_price/100);
                } else {
                    $.each(window.actionProduct.variants, function(i,d){
                        if(selected_variant.variant==d.id){
                            current_price = (d.price/100);
                        }
                    });
                }
                var main_quantity = 1;
                current_price = current_price*main_quantity;
                // GET THE PRICE FOR UNDERCOAT
                let new_price = parseFloat(current_price) + parseFloat((selected_undercoat_variant_price/100).toFixed(2));
                    new_price = new_price.toFixed(2);
                $(".block-price__container .money").html("$"+new_price+"new")
            }, 100);
        } else {
            setTimeout(() => {
                var current_price=0;
                var selected_variant = parseQueryString();
                if(undefined==selected_variant.variant){
                    current_price = window.actionProduct.variants[0].price
                    current_price = (current_price/100);
                } else {
                    $.each(window.actionProduct.variants, function(i,d){
                        if(selected_variant.variant==d.id){
                            current_price = (d.price/100);
                        }
                    });
                }
                var main_quantity = 1;
                current_price = current_price*main_quantity;
                // GET THE PRICE FOR UNDERCOAT
                let new_price = parseFloat(current_price);
                new_price = new_price.toFixed(2);
                $(".block-price__container .money").html("$"+new_price)
            }, 100);
        }
    });
    let pass_click = false;
    $(".yes-add").click(function(){
        pass_click = true;
        $(".ssr-oem-search-recommended-undercoat-checkbox").prop("checked",true);
        $(".add-to-cart").click();
        $("body").removeClass("overlay");
        $(".ssr-confirm-undercoat-popup").hide();
        pass_click = false;
    });
    $(".no-dont-add").click(function(){
        pass_click = true;
        $(".add-to-cart").click();
        $("body").removeClass("overlay");
        $(".ssr-confirm-undercoat-popup").hide();
        pass_click = false;
    });
  
	$(document).on("click", '.add-to-cart, .product-form__submit', function (e) {

        // Skip the secondary "Build a [category] bundle" CTA — it shares the
        // `.product-form__submit` class for visual parity with the main ATC,
        // but it's NOT an add-to-cart action. Without this guard the bundle
        // CTA gets hijacked into ATC behavior and opens the cart drawer.
        // Tommy: "The Build a Bundle button underneath the Add to Cart on
        // the product page opens the cart still."
        if ($(e.target).closest('[data-tss-build-bundle-cta-button]').length) {
            return;
        }

        if (Array.isArray(window.sellingPlans) && window.sellingPlans.length > 0) {
            console.log('has selling plan');
            return
        }
        console.log("no selling plan")
		e.preventDefault();

        /* ── Single-flight mutex shared with Dawn's <product-form> ────────
           Two ATC paths (this jQuery handler + Dawn's <product-form> submit
           handler) target the same /cart/add.js endpoint. preventDefault
           normally stops Dawn from also firing on a click, but programmatic
           submits (Enter key on quantity input), JS errors earlier in this
           handler, or rapid double-clicks can still produce parallel POSTs.
           Two parallel /cart/add.js calls in one session caused:
             - duplicate line items (different timestamps in attribution
               properties on the bundle path → Shopify treats as distinct)
             - "issue persists" silent-rejection alerts (one POST succeeds,
               the other 200s but cart didn't actually change)
             - spinner-hangs-forever (button left in spinner state after a
               racing request errored on a stale verification)
           window.__tssAtcInFlight is the lone source of truth — both paths
           respect it. Released on success, error, timeout, OR after the
           safety timer fires (in case all three callbacks somehow miss). */
        if (window.__tssAtcInFlight) {
            if (window.console) console.warn('[atc] click ignored — previous add still in flight');
            return;
        }
        window.__tssAtcInFlight = true;
        var _atcSafety = setTimeout(function () {
            if (window.__tssAtcInFlight) {
                window.__tssAtcInFlight = false;
                if (window.console) console.warn('[atc] safety release — request hung past 12s');
                $('.add-to-cart, .product-form__submit').each(function () {
                    if ($(this).closest('[data-tss-build-bundle-cta-button]').length) return;
                    $(this).html('Add to cart');
                });
            }
        }, 12000);
        function _atcRelease() {
            clearTimeout(_atcSafety);
            window.__tssAtcInFlight = false;
        }

        // ADDING ADD TO CART UPSELL IN FLOW PREVENTING DEFAULT ADD TO CART ON SPRAYCANS
        if (typeof window.add_to_cart_upSell !== 'undefined') {
            console.log("add_to_cart_upSell is active")
            return;
        }


        if($(".variant-input__select").length){
            if ('CHOOSE YOUR GUN MODEL HERE'==$(".variant-input__select").val() && window.actionProduct.id==6910560960630) {
                alert("Please choose your gun model.");
                return;
            }
        }
        if($("#ssr-oem-search-recommended-undercoat").is(":visible") && !$(".ssr-oem-search-recommended-undercoat-checkbox").is(":checked") && !pass_click){
            $("body").addClass("overlay");
            $(".ssr-confirm-undercoat-popup").show();
            return;
        }
		//get all the variant ids and add them to the cart
		var selected_variant = parseQueryString();


        // Extracting query parameters
        var params = new URLSearchParams(window.location.search);
        var objURL = {};
            params.forEach((value, key) => {
                objURL[key] = value;
            });
        console.log("Query String Parameters: ", objURL);
        // Get first variant details
        var firstVariant   = window.actionProduct.variants[0];  
        var firstVariantId = firstVariant.id;  
        var vendor         = firstVariant.vendor;  
        var pid            = firstVariant.id;  
		var item_arr       = [];
        // Get quantity value
        var cur_btn        = $('.add-to-cart, .product-form__submit');
        var main_quantity  = Number($('input[name=quantity]').val()) || 1; // Default to 1 if empty
        // Prepare cart item object
        var item_obj = {
            quantity: main_quantity,
            id: objURL.variant ? Number(objURL.variant) : firstVariantId // Default to first variant if undefined
        };

      console.log("1item_obj --- >",item_obj)
        // these attribute should be attached with OEM colors only
        if (window.__tssFooterCfg.oematch) {
        if ($('input[name="Code"]').length > 0) {

            item_obj.properties={
                "Color name": OEM_color_name,
                "Color code": OEM_color_code,
                "Make": OEM_color_make,
                "_MCC_REF_ID": OEM_mcc_id

            };
        }
        }
        
		item_arr.push(item_obj);
      console.log("2item_obj --- >",item_obj)
      
		cur_btn.html('<i class="fa fa-spinner fa-spin"></i> Adding to cart');
		$(".cldm-product-option.selected").each(function() {
			item_obj = {}
			var cur_variant = $(this).attr('value');
			var cur_quantity = $(this).find('.quantity-input').val();
			item_obj.quantity = Number(cur_quantity);
			item_obj.id = Number(cur_variant);
			item_arr.push(item_obj);
		});
      console.log("3item_obj --- >",item_obj)
      
        // Grab optional products data
        $.each(
            $("#tss-op-holder .op-template-1-selected .op-variants-select"),
            function (i,elm) {
            item_obj = {}
                if ($(elm).find('option').length==1) {
                    item_obj.id = Number($(elm).val());
                    item_obj.quantity = 1;
                    item_arr.push(item_obj);
                } else {
                    item_obj.id = Number($(elm).find("option:selected").val());
                    item_obj.quantity = 1;
                    item_arr.push(item_obj);
                }
            }
        );
        $.each(
            $("#tss-op-holder .op-template-2-selected .op-variants-select"),
            function (i,elm) {
            item_obj = {}
                if ($(elm).find('option').length==1) {
                    item_obj.id = Number($(elm).val());
                    item_obj.quantity = 1;
                    item_arr.push(item_obj);
                } else {
                    item_obj.id = Number($(elm).find("option:selected").val());
                    item_obj.quantity = 1;
                    item_arr.push(item_obj);
                }
            }
        );
        $.each(
            $("#tss-op-holder .op-template-3-selected .op-variants-select"),
            function (i,elm) {
            item_obj = {}
                item_obj.id = Number($(elm).val());
                item_obj.quantity = 1;
                item_arr.push(item_obj);
            }
        );
        $.each(
            $("#tss-op-holder .op-template-4-selected .op-variants-select"),
            function (i,elm) {
            item_obj = {}
                item_obj.id = Number($(elm).val());
                item_obj.quantity = 1;
                item_arr.push(item_obj);
            }
        );
      console.log("4item_obj --- >",item_obj)

        // Add undercoat into cart
        if($(".ssr-oem-search-recommended-undercoat-checkbox").length && $(".ssr-oem-search-recommended-undercoat-checkbox").is(":checked")) {
            item_obj = {}
            item_obj.properties={
                // "Undercoat name": $("#ssr-oem-search-undercoat-name").text()
                "Color code": $("#ssr-oem-search-undercoat-name").text(),
                'Info':"This is the undercoat for "+$('.color_code').text()
            };
            item_obj.id = Number(selectedUndercoatVariantId);
            item_obj.quantity = main_quantity;
            item_arr.push(item_obj);
        }  
        $(document).on('click', ".op-template-2 input[type=checkbox]", function() {
            if ($(this).is(":checked")) {
                $(this).closest("li").addClass('op-template-2-selected');
            } else {
                $(this).closest("li").removeClass('op-template-2-selected');
            }
        });
        vendor = "all"; //paused the kit stock check for now...

        
        if (vendor == 'TSS') {
            if (selected_variant.variant == undefined && !popupSelectedVariant) {
                var cur_var = Number(first_variant);
            } else {
                var cur_var = Number(selected_variant.variant);
            }
            $.ajax({
                url:"https://apps.ecomeasy.io/the-spray-source/check-variant-inventory.php?pid="+pid+"&vid="+cur_var+"&qt="+main_quantity,
                method: "get",
                contentType: "application/json",
                timeout: 8000,
                error: function () {
                    /* Inventory check failed/timed out — release mutex so the
                       customer can retry. Without this the spinner hangs and
                       the button is unclickable. */
                    _atcRelease();
                    alert('There was a problem checking inventory. Please try again.');
                    cur_btn.html('Add to cart');
                },
                success: function (res) {
                    if(res.status == "error") {
                        _atcRelease();
                        alert("Some of the kit products are out of stock.");
                        cur_btn.html('Add to cart');
                        return;
                    } else {
                        $.ajax({
                            type: 'POST',
                            url: '/cart/add.js',
                            data: {
                                items : item_arr
                            },
                            dataType: 'json',
                            timeout: 8000,
                            error: function(data) {
                                _atcRelease();
                                /* Defensive error extractor — see twin handler
                                   below for rationale. Never alert "undefined". */
                                var msg = 'There was a problem adding this to your cart. Please try again.';
                                try {
                                    var error_json = JSON.parse(data.responseText);
                                    if (error_json) {
                                        if (typeof error_json.description === 'string' && error_json.description) msg = error_json.description;
                                        else if (typeof error_json.message === 'string' && error_json.message) msg = error_json.message;
                                        else if (error_json.errors) {
                                            if (typeof error_json.errors === 'string') msg = error_json.errors;
                                            else if (Array.isArray(error_json.errors)) msg = error_json.errors.join('; ');
                                            else msg = Object.values(error_json.errors).flat().join('; ') || msg;
                                        }
                                    }
                                } catch (e) { /* not JSON */ }
                                if (window.console) {
                                    try {
                                        console.error('[cart/add error - selling-plan branch]', {
                                            status: data.status,
                                            statusText: data.statusText,
                                            responseText: data.responseText,
                                            sentItems: item_arr
                                        });
                                    } catch (_) {}
                                }
                                alert(msg);
                                cur_btn.html('Add to cart');
                                return;
                            },
                            success: function (res) {
                                _atcRelease();
                                cur_btn.html('<i class="fa-solid fa-check"></i> Added to cart');
                                setTimeout(function(){ cur_btn.html('Add to cart'); }, 5000);
                                /* Same cart:refresh dispatch as the other branch
                                   below — required for the ATC popup to fire on
                                   templates using this legacy jQuery ATC handler. */
                                try {
                                    document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { source: 'product-form' } }));
                                } catch (e) {}
                                /* Open cart drawer */
                                var cartDrawer = document.querySelector('cart-drawer');
                                if (cartDrawer) {
                                  fetch(window.routes.cart_url + '?sections=cart-drawer,cart-icon-bubble')
                                    .then(function(r) { return r.json(); })
                                    .then(function(sections) {
                                      cartDrawer.renderContents({ sections: sections });
                                      var bubble = document.getElementById('cart-icon-bubble');
                                      if (bubble && sections['cart-icon-bubble']) {
                                        bubble.innerHTML = new DOMParser()
                                          .parseFromString(sections['cart-icon-bubble'], 'text/html')
                                          .querySelector('.shopify-section').innerHTML;
                                      }
                                    });
                                }
                            }
                        });
                    }
                }
            });
        } else {
          console.log("here")
            /* Single-attempt /cart/add.js — no auto-retry.
               Earlier iterations layered a silent retry to mask first-click-
               fails behavior, but Tommy reported it making things WORSE:
               sometimes Shopify returned a 200 response that looked like
               success but the cart never actually updated, so the success
               handler showed "Added to cart" while the item never landed.
               That made the bug invisible AND confusing.

               Predictable beats clever. Now: single attempt, real success
               path runs only on real success (and we verify item_count
               increased before declaring it succeeded), and any failure
               surfaces the defensive alert + console.error log. Customers
               can retry manually — at least the behavior is consistent. */
            $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                data: {items : item_arr},
                dataType: 'json',
                timeout: 8000,
                error: function(data) {
                    _atcRelease();
                    /* Defensive error message extractor — Shopify's cart-add
                       errors don't always have a `description` field. Some
                       responses use `message`, some have `errors` arrays/objects,
                       some are plain HTML pages. Falling back through these
                       shapes ensures the customer never sees "undefined" again. */
                    var msg = 'There was a problem adding this to your cart. Please try again.';
                    try {
                        var error_json = JSON.parse(data.responseText);
                        if (error_json) {
                            if (typeof error_json.description === 'string' && error_json.description) msg = error_json.description;
                            else if (typeof error_json.message === 'string' && error_json.message) msg = error_json.message;
                            else if (error_json.errors) {
                                if (typeof error_json.errors === 'string') msg = error_json.errors;
                                else if (Array.isArray(error_json.errors)) msg = error_json.errors.join('; ');
                                else msg = Object.values(error_json.errors).flat().join('; ') || msg;
                            }
                        }
                    } catch (e) { /* responseText wasn't JSON — keep generic msg */ }
                    /* Log the full failure shape so future Claude sessions can
                       see exactly which payload Shopify rejected without
                       relying on the customer to screenshot the alert. */
                    if (window.console) {
                        try {
                            console.error('[cart/add error]', {
                                status: data.status,
                                statusText: data.statusText,
                                responseText: data.responseText,
                                sentItems: item_arr
                            });
                        } catch (_) {}
                    }
                    alert(msg);
                    cur_btn.html('Add to cart');
                    return;
                },
                success: function (res) {
                    /* Verify the cart actually changed before declaring success.
                       Tommy reported: "Even though it said added to cart, it
                       didn't add." Shopify can return a 200 success-shaped
                       response without actually adding the item (cart locked,
                       inventory race, validation rejection that didn't trip
                       the error handler). Re-fetch /cart.json and compare
                       item_count — if it didn't go up, treat as failure. */
                    if (window.console) {
                        try { console.log('[cart/add success]', { res: res, sentItems: item_arr }); } catch (_) {}
                    }
                    fetch('/cart.json', { credentials: 'same-origin' })
                      .then(function(r) { return r.json(); })
                      .then(function(cart) {
                          var actuallyAdded = cart && typeof cart.item_count === 'number' && cart.item_count > 0;
                          /* Note: we can't compare to a previous count here without
                             plumbing it through; we settle for "cart now has items
                             AND the response said items were added". If res.items
                             is empty array OR item_count didn't budge, treat as
                             a silent rejection. */
                          var responseHadItems = res && (
                              (Array.isArray(res.items) && res.items.length > 0) ||
                              (typeof res.id !== 'undefined' && typeof res.quantity !== 'undefined')
                          );
                          if (!responseHadItems || !actuallyAdded) {
                              _atcRelease();
                              if (window.console) console.error('[cart/add silent rejection]', { res: res, cart: cart, sentItems: item_arr });
                              alert('We could not add this item right now. Please try again in a moment, or contact us if the issue persists.');
                              cur_btn.html('Add to cart');
                              return;
                          }
                          /* Real success path. */
                          _atcRelease();
                          cur_btn.html('<i class="fa-solid fa-check"></i> Added to cart');
                          setTimeout(function(){ cur_btn.html('Add to cart'); }, 5000);
                          /* Fire cart:refresh with source: 'product-form' so the
                             ATC popup picks it up. Without this, the popup never
                             opens on legacy templates that use this jQuery ATC
                             handler instead of Dawn's <product-form> pubsub.
                             The popup itself filters on the source, so we tag
                             this as 'product-form' to mimic Dawn's signal. */
                          try {
                              document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { source: 'product-form' } }));
                          } catch (e) {}
                          /* Open cart drawer */
                          var cartDrawer = document.querySelector('cart-drawer');
                          if (cartDrawer) {
                            fetch(window.routes.cart_url + '?sections=cart-drawer,cart-icon-bubble')
                              .then(function(r) { return r.json(); })
                              .then(function(sections) {
                                cartDrawer.renderContents({ sections: sections });
                                var bubble = document.getElementById('cart-icon-bubble');
                                if (bubble && sections['cart-icon-bubble']) {
                                  bubble.innerHTML = new DOMParser()
                                    .parseFromString(sections['cart-icon-bubble'], 'text/html')
                                    .querySelector('.shopify-section').innerHTML;
                                }
                              })
                              .catch(function(e) { if (window.console) console.warn('[cart drawer render failed]', e); });
                          }
                      })
                      .catch(function(e) {
                          _atcRelease();
                          if (window.console) console.error('[cart/add post-success verify failed]', e);
                          /* Couldn't verify — assume success but log. Customer
                             would see button checkmark but no drawer; better
                             than silently failing. */
                          cur_btn.html('<i class="fa-solid fa-check"></i> Added to cart');
                          setTimeout(function(){ cur_btn.html('Add to cart'); }, 5000);
                      });
                }
            });
        }
    });

	if(jQuery.trim(jQuery("#kit-content").html())!='') {
		let kcontent='';
		let text=''
		jQuery("#kit-content ul").each(function(i,d) {

			text+=`<details>`;
			
			let tab_content='';
			jQuery(d).find('li').each(function(i1,d2) {
				if (i1==0) {
					text+= `
					<summary class="kit-content-summary">${jQuery(d2).text()}
						<span class="collapsible-trigger__icon collapsible-trigger__icon--open" role="presentation">
							<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--wide icon-chevron-down" viewBox="0 0 28 16">
								<path d="M1.57 1.59l12.76 12.77L27.1 1.59" stroke-width="2" stroke="#000" fill="none" fill-rule="evenodd"></path>
							</svg>
						</span>
					</summary>`;
				} else {
					tab_content += `<div>${jQuery(d2).text()}</div>`;
				}
			});
		
			text+= `<div class="kit-content-holder" style="font-size: 16px;padding: 20px 0;">${tab_content}</div>`;
			text+=`</details>`;
		});

		kcontent += text;
		
		jQuery("#kit-content").empty();
		
		jQuery("#kit-content").closest('.product-block').after(`
		<div class="product-block product-block--tab">
			<details>
				<summary class="kit-content-summary">Contents of this kit 
					<span class="collapsible-trigger__icon collapsible-trigger__icon--open" role="presentation">
						<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--wide icon-chevron-down" viewBox="0 0 28 16">
							<path d="M1.57 1.59l12.76 12.77L27.1 1.59" stroke-width="2" stroke="#000" fill="none" fill-rule="evenodd"></path>
						</svg>
					</span>
				</summary>
				<div class="test-abhi">${kcontent}</div>
			</details>
		</div>`);
		jQuery(document).on("click", jQuery(".kit-content-summary"), function(elm){
			jQuery(elm.target).toggleClass('summary-open');
		});
		show_right_kit_contents();
	}

	$(".variant-wrapper select").change(function(){
		show_right_kit_contents();
	});

	if (window.innerWidth <= 425) {
		// if on mobile
		if ($(".cldm-collection-grid .grid-item").length < 4) {
			$(".cldm-collection-grid").css('justify-content', 'center');
		}
	}
	if (window.innerWidth > 460) {
		// if on desktop
		if ($(".cldm-collection-grid .grid-item").length < 5) {
			$(".cldm-collection-grid").css('justify-content', 'center');
		}
	}
	// if (window.outerWidth > 425) {
    	// $(".tss-professionals").css("left", $(".site-header__logo").offset().left + "px").fadeIn();
    // }
	if (window.innerWidth > 425) {
    	if ($(".ssr-sub-collections .grid-item").length < 12) {
    		$(".ssr-sub-collections").attr("style", "display: flex;flex-wrap: nowrap;justify-content: center !important;");
    	}
    }
	if ($(".ssr-sub-collections .grid-item").length == 0) {
		$(".ssr-sub-collections").hide();
	}
    if(""==$.trim($(".related-products-ssr").text())){
        $(".related-products-ssr-container").hide()
    }
	// End


});


// Custom functions
function openPopup(divPopup) {
	$(divPopup).fadeIn(250);
	$('#shopify-section-header').css('position','absolute');
	$('#shopify-section-header').css('z-index','0');
}
function closePopup(divPopup) {
	$(divPopup).fadeOut(250);
	$("#bundle-sticky_add_to_cart").show();
	$("#shopify-section-header").removeAttr("style")
}
function update_OEM_price(selected_undercoat_variant_price) {
	setTimeout(() => {
		var current_price=0;
		var selected_variant = parseQueryString();
		if(undefined==selected_variant.variant){
			current_price = window.actionProduct.variants[0].price
			current_price = (current_price/100);
		} else {
			$.each(window.actionProduct.variants, function(i,d){
				if(selected_variant.variant==d.id){
					current_price = (d.price/100);
				}
			});
		}
		var main_quantity = 1;
		current_price = current_price*main_quantity;
		// GET THE PRICE FOR UNDERCOAT
		let new_price = parseFloat(current_price) + parseFloat(selected_undercoat_variant_price);
			new_price = new_price.toFixed(2);
			$(".block-price__container .money").html("$"+new_price)
	}, 1000);
}
var get_sel_options_price = function(current_price) {
	return new Promise( ( resolve , reject ) => {
		var total_options_price = 0;
		$(".cldm-product-option.selected").each(function() {
			var cur_price = parseFloat($(this).data('price'));
			var cur_quantity = $(this).find('.quantity-input').val();
			var cur_price_with_quantity = cur_price * cur_quantity;
			cur_price_with_quantity = cur_price_with_quantity.toFixed(2);
			total_options_price = parseFloat(total_options_price) + parseFloat(cur_price_with_quantity);
		});
		var new_price = parseFloat(current_price) + parseFloat(total_options_price);
		new_price =new_price.toFixed(2);
		new_price2 = new_price;
		new_price = new_price.split('.');
		p1 = new_price[0];
		p2 = new_price[1];
		$(".product-block--price .product__price .money").html('$'+new_price2);
		resolve(total_options_price);
	});
};
var parseQueryString = function() {
    var params = new URLSearchParams(window.location.search);
    var objURL = {};
    params.forEach((value, key) => {
        objURL[key] = value;
    });
    console.log("qr st ", objURL)
    return objURL;
};
function show_right_kit_contents(params) {
	let title_of_variant=[];
	$(".variant-wrapper").each(function(i,d){
		title_of_variant.push($.trim($(d).find("select").val()));
	});
	$(".test-abhi .kit-content-summary").each(function (i,d) {
		$(d).parent().hide();
		if ( $.trim($(d).text())==title_of_variant.join(" / ")) {
			$(d).parent().show();
			$(d).click();
		}
	});
}
function update_cart_count() {
	$.ajax({
		url: "/cart.js",
		method: "get",
		dataType: "json",
		success: function (cart_data) {
			// let shipping_insurance_exist_in_cart = false;
			// for (let index = 0; index < cart_data.items.length; index++) {
			// 	const item = cart_data.items[index];
			// 	if (item.handle.indexOf("shipping-insurance") > -1 || item.handle.indexOf("denied-shipping-coverage") > -1) {
			// 		shipping_insurance_exist_in_cart = true;
			// 		break;
			// 	}
			// }
			// if (shipping_insurance_exist_in_cart) {
				// $(".cart-link__bubble-num-cldmapps").text(cart_data.item_count - 1);
			// } else {
				// $(".cart-link__bubble-num-cldmapps").text(cart_data.item_count);
			// }
		},
	});
}
(function (ns, fetch) {
	if (typeof fetch !== "function") return;
	ns.fetch = function () {
		var out = fetch.apply(this, arguments);
		out.then(function (a, b) {
			// update_cart_count();
			if (a.url.indexOf("add.js") > -1) {
				// update_cart_count();
			}
		});
		return out;
	};
})(window, window.fetch);
if (window.__tssFooterCfg.premix) {
    console.log("template name");
    $('block-variant-picker').css("width","100%");
    $(".variant-wrapper.variant-wrapper--dropdown").width("100%");
}
